package one.healthium.insights.data

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.flow
import one.healthium.insights.data.mapper.ContentScreenMapper
import one.healthium.insights.data.sources.network.ContentApiClient
import one.healthium.insights.domain.models.ContentScreenModel
import one.healthium.insights.domain.workouts.WorkoutsRepository

internal class AppWorkoutsRepository(
    private val apiClient: ContentApiClient,
    private val contentScreenMapper: ContentScreenMapper,
) : WorkoutsRepository {

    private var screenCache: ContentScreenModel? = null

    override fun getScreen(): Flow<ContentScreenModel> {
        return flow {
            val cachedValue = screenCache
            if (cachedValue != null) {
                emit(cachedValue)
            }
            val contentScreenDto = apiClient.getWorkoutsScreen()
            val contentScreenModel = contentScreenMapper.dtoToModel(contentScreenDto)
            screenCache = contentScreenModel
            emit(contentScreenModel)
        }.distinctUntilChanged()
    }
}